export default __webpack_public_path__ + "static/media/ic_alerta.18744059.svg";